import { useEffect, useState } from "react";
import { masterFetch } from "./masterApi";
import MasterLayout from "./MasterLayout";

function fmtHours(h) {
  if (!h) return "0h";
  const hr = Math.floor(h);
  const min = Math.round((h - hr) * 60);
  return min > 0 ? `${hr}h ${min}m` : `${hr}h`;
}

function fmtLastSeen(iso) {
  if (!iso) return "never";
  const then = new Date(iso).getTime();
  const age = Math.floor((Date.now() - then) / 1000);
  if (age < 60) return `${age}s ago`;
  if (age < 3600) return `${Math.floor(age / 60)}m ago`;
  if (age < 86400) return `${Math.floor(age / 3600)}h ago`;
  return `${Math.floor(age / 86400)}d ago`;
}

export default function MasterOperatorHours() {
  const [days, setDays] = useState(7);
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    masterFetch(`/operators/hours?days=${days}`)
      .then((d) => { setRows(d.operators || []); setError(""); })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, [days]); // eslint-disable-line

  const total = rows.reduce((s, r) => s + (r.total_seconds || 0), 0);
  const onlineNow = rows.filter((r) => r.is_online_now).length;

  return (
    <MasterLayout>
    <div data-testid="master-operator-hours">
      <div style={{ fontSize: 11, letterSpacing: 3, opacity: 0.5 }}>MESSAGE HUB</div>
      <h1 style={{ fontSize: 26, margin: "4px 0 4px" }}>Operator Hours</h1>
      <p style={{ opacity: 0.6, marginTop: 0, marginBottom: 20, fontSize: 13 }}>
        Total hours each operator has been logged on to the Message Hub across all tenants.
      </p>

      <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 20 }}>
        {[1, 7, 30, 90].map((d) => (
          <button
            key={d}
            data-testid={`hours-range-${d}`}
            onClick={() => setDays(d)}
            style={{
              padding: "8px 14px", borderRadius: 8,
              background: days === d ? "rgba(139,92,246,0.24)" : "transparent",
              border: `1px solid ${days === d ? "rgba(139,92,246,0.55)" : "#2b1e42"}`,
              color: days === d ? "#fff" : "#a89ec9",
              cursor: "pointer", fontSize: 12,
            }}
          >
            {d === 1 ? "24h" : `${d}d`}
          </button>
        ))}
        <div style={{ marginLeft: "auto", fontSize: 12, opacity: 0.7 }}>
          <span data-testid="hours-online-count" style={{ color: "#22c55e" }}>● {onlineNow} online</span>
          {"  ·  "}
          <span data-testid="hours-total">Total: {fmtHours(total / 3600)}</span>
        </div>
      </div>

      {error && (
        <div style={{
          padding: 12, background: "rgba(239,68,68,0.14)",
          border: "1px solid rgba(239,68,68,0.5)", borderRadius: 8,
          marginBottom: 16, fontSize: 13, color: "#fca5a5",
        }}>Failed to load: {error}</div>
      )}

      {loading && !rows.length ? (
        <div style={{ opacity: 0.5 }}>Loading…</div>
      ) : rows.length === 0 ? (
        <div data-testid="hours-empty" style={{
          padding: 24, background: "#110720", border: "1px solid #1f1232",
          borderRadius: 12, opacity: 0.7, fontSize: 14,
        }}>
          No operator sessions in this range. Operators must sign in to the Message Hub
          to start tracking hours.
        </div>
      ) : (
        <div style={{ display: "grid", gap: 8 }}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "18px 2fr 1fr 1fr 1fr 1fr",
            gap: 14, padding: "0 16px",
            fontSize: 11, letterSpacing: 1, opacity: 0.55,
          }}>
            <span></span><span>OPERATOR</span><span>TENANT</span>
            <span>SESSIONS</span><span>LAST SEEN</span><span>HOURS</span>
          </div>
          {rows.map((r) => (
            <div
              key={r.operator_id}
              data-testid={`operator-row-${r.operator_id}`}
              style={{
                display: "grid",
                gridTemplateColumns: "18px 2fr 1fr 1fr 1fr 1fr",
                gap: 14, alignItems: "center",
                padding: "14px 16px",
                background: "#110720", border: "1px solid #1f1232",
                borderRadius: 10, fontSize: 13,
              }}
            >
              <span
                title={r.is_online_now ? "online now" : "offline"}
                style={{
                  width: 10, height: 10, borderRadius: "50%",
                  background: r.is_online_now ? "#22c55e" : "#5b5170",
                  boxShadow: r.is_online_now ? "0 0 8px #22c55e" : "none",
                }}
              />
              <div style={{ color: "#fff", fontWeight: 600 }}>{r.username || r.operator_id}</div>
              <div style={{ opacity: 0.75, fontSize: 12 }}>{r.tenant_id}</div>
              <div>{r.sessions}</div>
              <div style={{ fontSize: 12, opacity: 0.85 }}>{fmtLastSeen(r.last_seen)}</div>
              <div style={{ color: "#c4b5fd", fontWeight: 600 }}>{fmtHours(r.total_hours || 0)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
    </MasterLayout>
  );
}
